import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './style.scss?inline';

/**
 * @attribute {string} selected
 * @attribute {boolean} disabled
 *
 * @event select - Emitted when the color is selected via click
 *
 * @slot - An icon or a similar element displayed when the color is selected
 *
 * @csspart outline - A decorative outline around the color part
 * @csspart color - An element filled with the displayed color
 * @csspart icon - A wrapper for an icon displayed when the color is selected
 *
 * @cssproperty --color - Controls the displayed color
 */
export default class SotbitColor extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    connectedCallback() {
        super.connectedCallback();

        this.addEventListener('click', this._handleClick.bind(this));
    }

    _handleClick() {
        if (this.getAttribute('disabled') !== null) {
            return;
        }

        this.setAttribute('selected', '');
        this.dispatchEvent(
            new Event('select', {
                bubbles: true,
                composed: true,
                cancelable: false,
            })
        );
    }

    render() {
        return html`
            <div part="outline"></div>
            <div part="color"></div>
            <div part="icon">
                <slot>
                    <sotbit-icon icon="check" size="xxl" theme="dark"></sotbit-icon>
                </slot>
            </div>
        `;
    }
}
